/* eslint-disable */
import React, {useState, useEffect} from 'react';

// component
import Table from 'components/TableV2/index';
import H5 from 'components/H5';
import LoadingBox from 'components/LoadingBox.js';
import moment from 'moment';
import _ from 'lodash';
import styled from 'styled-components';
import Badge from "components/Badge";
import NoData from './NoData';
import Svg from "_assets/svg";
import Modal from 'components/Modal/index';
import { Alert,AlertType } from "utils/Alert";
import FeatherIcon from 'feather-icons-react';
import {useMutation} from '@tanstack/react-query';
// style
import './wa_template.scss'

// library
import ReactPaginate from 'react-paginate';
import { useHistory } from "react-router-dom";

const Div = styled.div`
 
  // @media only screen and (max-width: 1024px) {
  //   display: none !important;
  // }
`;

const SetLoadingBox = (count) => {
  let i;
  const data = [];
  for (i = 0; i < count; i += 1) {
    data.push(
      <tr>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
        <td>
          <LoadingBox height={10} borderRadius={8} />
        </td>
      </tr>
    );
  }
  return data;
};

// Services
import waTemplateSvc from "services/waTemplateSvc";
import PreviewTemplate from './PreviewTemplate';

const TableData = (props) => {
  const [searchCriteria, setSearchCriteria] = useState({});
  const [isIndexActiveDots, setIndexActiveDots] = useState();
  const [isShowDots, setShowDots] = useState(false);
  const [isOpenModal, setOpenModal]=useState(false);
  const [isOpenModalDuplicate, setOpenModalDuplicate]=useState(false);
  const { isDataUser, isLoadingGetList,isPagination,changeCriteria, handleListReport } = props;
  const [dataFilter,setDataFilter]=useState([]);
  const [choosen,setChoosen]=useState([]);
  const [checkAll,setCheckAll]=useState(false);
  const [showAlerts,setShowAlerts]=useState(false);
  const [isShowAlertsDuplicate,setShowAlertsDuplicate]=useState(false);
  const [isPreviewTemplate,setPreviewTemplate]=useState(false);
  const [isInfoSelected,setInfoSelected]=useState({status:'',data:''});
  const isNoData = isDataUser?.length <= 0 && !isLoadingGetList;
  const history = useHistory();

  const convertDate = (created_at,estimated_time) =>{
    let date = created_at + estimated_time !== undefined && estimated_time
    console.log('value',date)
    return moment(date).format('DD-MM-YYYY h:mm:ss A')
  }

  useEffect(()=>{
    clearChoosed();
    setDataFilter(isDataUser);
},[isDataUser]);

  function handlePageClick(e){
    const selectedPage = e.selected + 1;
    let data = searchCriteria;
    data.page = selectedPage;
    data.limit = 10;
    setSearchCriteria(searchCriteria)
    changeCriteria(searchCriteria);
  }


  function handleDots(index){
    setIndexActiveDots(index)
    setShowDots(!isShowDots)
  }

  function handleShowDeleteModal(val){
    console.log('vall',val)
    setOpenModal(true)
    setShowDots(false)
  }

  function clearChoosed(){
    setChoosen([]);
}

function selectAll(e){
    clearChoosed();
    
    setCheckAll(e.target.checked);
    
    if (dataFilter.length > 0) {
        let choosed=[];

        const newFilters = dataFilter.map(val => {
            choosed.push(val.template_id);
            val.checked = e.target.checked
            return val
        })

        if(e.target.checked){
            setChoosen(choosed);
        }
        setDataFilter(newFilters)
    }
}

function handleChecked(e,index){
    setCheckAll(false);
    let checkAll=true;
    let choosed=choosen;

    const newFilters = dataFilter.map((val, i) => {
        if (i === index) {
            val.checked = e.target.checked
            if(e.target.checked){
                choosed.push(val.template_id);
            }else{
                let choosedIndex=choosed.findIndex((el)=>el==val.template_id);
                if(choosedIndex>-1){
                    choosed.splice(choosedIndex,1);
                }
            }
        } 
        if(!val.checked){
            checkAll=false
        }
        return val
    })
    setChoosen(choosed);
    setDataFilter(newFilters)
    

    if(checkAll){
      setCheckAll(checkAll);
    }
}

function handleDeleteSelected(status,value){
  setShowDots(false)
  setOpenModal(true)
  setInfoSelected({status:status,data:value})
}

async function handleSaveActionModal(value){
  console.log('valuee',value)
  if(value.status === 'bulk'){
    await deletedBulk();
  }else{
    deleteSingle(value.data)
  }
}

const {mutate: deletedBulk } = useMutation({
  mutationFn: async () => {
   const responseData = await waTemplateSvc.deleteTemplateBulk({template_ids:choosen})

   return responseData;
  },
  onSuccess: () => {
    setCheckAll(false)
    Alert.showStatus(
      AlertType.SUCCESS,
      'Success!',
      'Success! Template deleted'
    )
    handleListReport()
  },
  onError: (error) => {
    Alert.showStatus(
      AlertType.ERROR,
      'Error!',
      error.message
    )
  }
})

const {mutate: deleteSingle } = useMutation({
  mutationFn: async (data) => {
   const responseData = await waTemplateSvc.deleteTemplateBulk({template_ids: [data.template_id]})

   return responseData;
  },
  onSuccess: (data) => {
    if(!data.data.success){
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        data.data.errors.message
      )
    }

    if(data.data.success){
      Alert.showStatus(
        AlertType.SUCCESS,
        'Success!',
        'Success! Template deleted'
      )
      handleListReport()
    }
  },
  onError: (error) => {
    Alert.showStatus(
      AlertType.ERROR,
      'Error!',
      error.message
    )
  }
})


function handleSaveActionModalDuplicate(data){
  handleDuplicateTemplate(data)
}

async function handlePreviewTemplateModal(data){
  setShowDots(false)
  setPreviewTemplate(true)
  setInfoSelected({status:'',data:data})
}

async function handleDuplicateTemplateModal(data){
  setShowDots(false)
  setOpenModalDuplicate(true)
  setInfoSelected({status:'',data:data})
}


async function handleDuplicateTemplate(data){
  let reqBody = {
    template_id:data.data.template_id
  }
  await waTemplateSvc.duplicateTemplate(data.data.template_id,reqBody)
  .then((res)=>{
    if(res.data.data){
      Alert.showStatus(
        AlertType.SUCCESS,
        'Success!',
        'Success! Template Duplicate'
      )
      handleListReport()
    }
  })
  .catch((error)=>{
    Alert.showStatus(
      AlertType.ERROR,
      'Error!',
      error.message
    )
  })
}

 function handleEditTemplate(data){
  data.edit = true;

  history.push({
    pathname: `/new-whatsapp-template/edit/${data.template_id}`,
    state: { dataChooseTypeTemplate: data, id: data.template_id, data },
  });
 }

  return (
    <Div className="d-flex flex-column pb-3 position-relative">
      <PreviewTemplate 
        isPreviewTemplate={isPreviewTemplate} 
        setPreviewTemplate={setPreviewTemplate} 
        isInfoSelected={isInfoSelected}
      ></PreviewTemplate>
      <Modal
        classNames="w-400"
        isOpenModal={isOpenModal} 
        setOpenModal={setOpenModal}
        action1="Close"
        action2="Delete"
        handleSaveAction={handleSaveActionModal}
        isInfoSelected={isInfoSelected}
        title="Delete Template?"
        wording="Delete templates cannot be restored. Are you sure you want to delete this template?"
      ></Modal>
      <Modal
        classNames="w-400"
        isOpenModal={isOpenModalDuplicate} 
        setOpenModal={setOpenModalDuplicate}
        action1="Close"
        action2="Duplicate"
        handleSaveAction={handleSaveActionModalDuplicate}
        isInfoSelected={isInfoSelected}
        title="Duplicate Template?"
        wording="Are you sure duplicate this template?"
      ></Modal>
      <div className={`${choosen.length < 1 && 'd-none'} wrapper_selected d-flex align-items-center`}>
        <div className='d-flex align-items-center'>
          <span className='icon'>i</span>
          <div className='wording'><span> {choosen.length} template selected.</span> Do you want to delete the selected template?</div>
        </div>
        <div onClick={()=>handleDeleteSelected('bulk','')} className='btn-generate-report'>
          <h5 className="fw-bold btn-generate">
            Delete
          </h5>
        </div>
      </div>
      <Table className={`${isNoData && `margin-bottom-40`}`}>
        <thead>
          <tr>
            <th className="col-sm-1 input_custom_dash color-grey">
              <div className='d-flex align-items-center'>
                <input className='mr-10-desktop' type="checkbox" 
                  onChange={selectAll} checked={checkAll}/>
                Template Name
              </div>
            </th>
            <th className="col-sm-1 color-grey">Date</th>
            <th className="col-sm-1 color-grey text-center">Status</th>
            <th className='col-sm-1 color-grey'>Template Code</th>
            <th className="col-sm-1 text-center color-grey">Notes</th>
            <th className="col-sm-1 text-center color-grey">Action</th>
          </tr>
        </thead>
        <tbody>
          {!isNoData && (
            <>
              {isLoadingGetList && SetLoadingBox(10)}
              {!isLoadingGetList && dataFilter?.length > 0 && dataFilter.map((val,index) => {
                return (
                  <tr key={val._id} className='table_row_custom'>
                    <td className="input_custom_dash">
                      <div className='title_template d-flex align-items-center'>
                        <input className='mr-10-desktop' type="checkbox"
                          checked={val.checked}
                          onChange={(e) => handleChecked(e,index)}/>
                          <div onClick={()=>handlePreviewTemplateModal(val)}>
                            {val.template_name ? val.template_name : '-'}
                          </div>
                      </div>
                    </td>
                    <td onClick={()=>handlePreviewTemplateModal(val)} className="">{moment(val.created_at).format('DD-MM-YYYY h:mm:ss A')}</td>
                    <td onClick={()=>handlePreviewTemplateModal(val)} className={`tooltipViewerMode text-center`}>
                      {val.status === 'Approved' && (
                        <Badge
                          // title={val.status}
                          textColor='#35B86D'
                          backgroundColor='#CEFFE3'
                          fontSize='12px'
                        >
                          {val.status}
                        </Badge>
                      )}
                      {val.status === 'Reviewed' && (
                        <Badge
                          // title={val.status}
                          textColor='#FF8B00'
                          backgroundColor='#FFFAE6'
                          fontSize='12px'
                        >
                          {val.status}
                        </Badge>
                      )}
                       {val.status === 'all' && (
                        <Badge
                          // title={val.status}
                          textColor='#FF8B00'
                          backgroundColor='#FFFAE6;'
                          fontSize='12px'
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                       {val.status === 'Requested' && (
                        <Badge
                          // title={val.status}
                          textColor='#2F80ED'
                          backgroundColor='#EAF3FF;'
                          fontSize='12px'
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                       {val.status === 'Draft' && (
                        <Badge
                          // title={val.status}
                          textColor='#878799'
                          backgroundColor='#f6f6ff;'
                          fontSize='12px'
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                        {val.status === 'Rejected' && (
                        <Badge
                          // title={val.status}
                          textColor='#EB5757'
                          backgroundColor='#FFF0F0'
                          fontSize='12px'
                        >
                          {val.status}
                          <div className={`${val?.additional_info?.reason ? 'tooltipTextViewerMode' : 'd-none'}`}>
                            <span className="tooltiptext">{val?.additional_info?.reason ? val?.additional_info?.reason : '~'}</span>
                          </div>
                        </Badge>
                      )}
                    </td>
                    <td onClick={()=>handlePreviewTemplateModal(val)} className="">
                      <span className='template_code'>{val.template_code_id ? val.template_code_id : '-'}</span>
                      </td>
                    <td onClick={()=>handlePreviewTemplateModal(val)} className='text-center'>{val.notes ? val.notes : '-'}</td>
                    <td className='text-center position-relative'>
                      <div onClick={()=>handleDots(index)} className={`${isShowDots && index === isIndexActiveDots ? 'bg_active' : 'bg_inactive'} wrapp_dots`}>
                      {isShowDots && index === isIndexActiveDots ? 
                        <img src={Svg.dots_active.default}/> :
                        <img src={Svg.dots_inactive.default}/>
                      }
                      </div>
                      {isShowDots && index === isIndexActiveDots &&
                      <div className={`wrap_modal_dots nav-action`}>
                        <div onClick={()=>handlePreviewTemplateModal(val)} className='mb-2 item'><img className='margin-right-12' src={Svg.preview.default}/><span className=''>Preview</span></div>
                        {val.status === 'Draft' || val?.status === 'Rejected' ?
                        
                        <div onClick={()=>handleEditTemplate(val)} className='mb-2 item'>
                          <FeatherIcon icon="edit-3" className="margin-right-12" width="17" />
                          <img className='margin-right-12 d-none' src={Svg.preview.default}/>
                          <span className=''>Edit</span></div>
                        :
                        <div></div>
                        }
                        <div onClick={()=>handleDuplicateTemplateModal(val)} className='mb-2 item'><img className='margin-right-12' src={Svg.duplicate.default}/><span>Duplicate</span></div>
                        <div onClick={()=>handleDeleteSelected('single',val)} className='item'><img className='margin-right-12' src={Svg.deleted.default}/><span>Delete</span></div>
                      </div>
                      }
                    </td>
                  </tr>
                );
              })}
            </>
          )}
        </tbody>
      </Table>
      {!isNoData && (
      <div className="selector-none mt-2 text-sm flex-1 d-flex items-center justify-content-between align-items-center">
          <div className="d-flex flex-row btn-total-data">
              <div className="">Total : {isPagination.total_all}</div>
          </div>
        <div className="flex flex-row flex-wrap">
          <ReactPaginate
            previousLabel="&#10094;"
            nextLabel="&#10095;"
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={isPagination.pages}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            forcePage={isPagination.page ? isPagination.page - 1 : ''}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}/>
        </div>
      </div>
      )}
      {isNoData && <NoData />}
    </Div>
  );
};

export default TableData;
